import { createSlice } from '@reduxjs/toolkit';

export const totalInfoSlice = createSlice({
    name: 'totalInfo',
    initialState: true,
    reducers: {
        setNeedUpdateTotalInfo: (state, action) => action.payload,
    },
});

export const { setNeedUpdateTotalInfo } = totalInfoSlice.actions;

export default totalInfoSlice.reducer;
